export const API_MAMABOI = 'https://mamaboi.rotendaokab.go.id/api/';
